import { getSubtodoPropertiesForInsert } from 'owa-todo-utils';
import { findInArray, getProjectTasksParentFolderId, ProjectId } from 'owa-timestream-asset-sdk';
import { todoCache, createFolderIdDescriptor, updateSubtodo } from 'owa-timestream-asset-sdk-tasks';

export default function handleSubtaskDrop(
    projectId: ProjectId,
    parentTaskId: string,
    draggedSubtaskId: string,
    targetSubtaskId?: string
): void {
    const subtasks = todoCache.getTaskForLock(
        parentTaskId,
        createFolderIdDescriptor(getProjectTasksParentFolderId(projectId))
    )?.Subtasks;
    if (!subtasks) {
        return;
    }

    const targetIndex = targetSubtaskId
        ? findInArray(subtasks, subtask => subtask.Id === targetSubtaskId)?.index
        : subtasks.length;
    if (targetIndex == null) {
        return;
    }

    const updatedSubtodoProperties = getSubtodoPropertiesForInsert(targetIndex, subtasks);
    updateSubtodo(updatedSubtodoProperties, parentTaskId, draggedSubtaskId);
}
